
<mat-card appearance="outlined" class="card-header">
  <!--mat-card-header>
    <mat-card-title>
      <div class="view-component-title">
        <span class="title">Configuração de Dados - JSON</span>
      </div>
    </mat-card-title>
  </mat-card-header-->
  <div fxLayout="row"  fxLayoutAlign="start center" class="headerRow">
    <mat-icon color="primary">info</mat-icon>
    <span style="margin-left: 5px;"><strong>Configuração Selecionada:</strong> {{ configHeader || 'Selecione uma configuração ou crie uma nova.' }}</span>
  </div>
  <mat-card-content style="margin-top: 10px">    
    <div  fxLayout="row" fxLayoutGap="10px">     
      <mat-form-field *ngIf="uas.user.companylist.length > 1 ">
        <mat-label>Escolher uma Empresa</mat-label>
        <mat-select [disabled]="disabled" [(ngModel)]="codecompany" (selectionChange)="getActiveCompanies()">
            <mat-option *ngFor="let data of uas.user.companylist" [value]="data.codecompany">
                {{data.codecompany}} - {{data.companyname}}
            </mat-option>
        </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Visibilidade</mat-label>
            <mat-select [(ngModel)]="configVisibility">
              <mat-option *ngFor="let opt of visibilityOptions" [value]="opt.value">
                {{ opt.label }}
              </mat-option>
            </mat-select>
        </mat-form-field>
       <div fxLayout="row" fxLayoutGap="10px" class="margin-top10">
          <!-- Botão: Criar Nova Configuração -->
          <button mat-raised-button color="primary" (click)="openDPARAModal(false)">
            <mat-icon>add</mat-icon> Nova Configuração
          </button>

          <!-- Botão: Editar Configuração (só aparece se tiver uma selecionada) -->
          <button mat-raised-button color="accent" *ngIf="idRule" (click)="openDPARAModal(true)">
            <mat-icon>edit</mat-icon> Editar Configuração
          </button>
        </div> 
    </div>
    
  </mat-card-content>
</mat-card>
<div class="view-component"> 
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" ngClass="custom-tabs combined-tab" (selectedTabChange)="onTabChanged($event);">
      <mat-tab id="Mktpjsonrule"> 
          <ng-template mat-tab-label>
              Configurações
          </ng-template>
          <div class="content">         
            <simple-datagrid #datagridCfg entityName="Mktpjsonrule" [parentRow]="parentRow" [selectedRow]="selecteRow" [condition]="conditionCfg" [getCondition]="getConditionFunction" [events]="eventsSubject.asObservable()"></simple-datagrid>
          </div>                    
      </mat-tab>    
    </mat-tab-group>    
</div> 
